export const UserRolesEnum = {
   SuperAdmin: "fab4fac1-c546-41de-aebc-a14da6895711",
   Staff: "c7b013f0-5201-4317-abd8-c211f91b7330",
   InternationalOrganization: "b74ddd14-6340-4840-95c2-db12554843e5",
   NationalOrganization: "c7b013f0-5201-4317-abd8-c211f91b7332",
   Donor: "b74ddd14-6340-4840-95c2-db12554843e6",
   Manager: "be05fa68-d26c-4ca5-8e86-01484cb33bb2", //workspace admin
   Consultant: "b74ddd14-6340-4840-95c2-db12554843e0",
   Approver: "d1a7e5c8-3f42-4b16-9a58-7c0e2d94b3f1"
};

export const UserRoles = [
   {
      id: "fab4fac1-c546-41de-aebc-a14da6895711",
      label: "Super Admin",
      translationKey: "role-super-admin-label"
   },
   {
      id: "c7b013f0-5201-4317-abd8-c211f91b7330",
      label: "Staff",
      translationKey: "staff-word"
   },
   {
      id: "b74ddd14-6340-4840-95c2-db12554843e5",
      label: "International Organization",
      translationKey: "role-international-organization-label"
   },
   {
      id: "c7b013f0-5201-4317-abd8-c211f91b7332",
      label: "National Organization",
      translationKey: "role-national-organization-label"
   },
   {
      id: "b74ddd14-6340-4840-95c2-db12554843e6",
      label: "Donor",
      translationKey: "role-donor-label"
   },
   {
      id: "be05fa68-d26c-4ca5-8e86-01484cb33bb2",
      label: "Manager",
      translationKey: "manager-label"
   },
   {
      id: "b74ddd14-6340-4840-95c2-db12554843e0",
      label: "Consultant",
      translationKey: "role-consultant-label"
   },
   {
      id: "d1a7e5c8-3f42-4b16-9a58-7c0e2d94b3f1",
      label: "Approver",
      translationKey: "approver-label"
   }
];

// Maps a role's raw backend name (as returned in `user.roles[0].name`, a
// member-list `role` field, etc.) to its i18n translation key. Backend
// spelling is inconsistent — e.g. "SuperAdmin" (no space) vs "National
// Organization" (with a space) — so this must match that exact spelling.
export const ROLE_NAME_TRANSLATION_KEYS = {
   SuperAdmin: "role-super-admin-label",
   Staff: "staff-word",
   Consultant: "role-consultant-label",
   Expert: "profile-expert-label",
   Vendor: "role-vendor-label",
   Donor: "role-donor-label",
   Manager: "manager-label",
   Approver: "approver-label",
   "National Organization": "role-national-organization-label",
   "International Organization": "role-international-organization-label"
};

// Falls back to the raw role name itself for anything not in the map above
// (an unrecognized/future backend role), so the UI never shows `undefined`
// or crashes on an unknown value.
export const translateRoleName = (rawRoleName, t) => {
   if (!rawRoleName) return "";
   const translationKey = ROLE_NAME_TRANSLATION_KEYS[rawRoleName];
   return translationKey ? t(translationKey) : rawRoleName;
};

// Role names the backend can report as the session's ActiveRole, mapped to the
// role ids the route guards and menus above are written against. "Expert" and
// "Vendor" are both backend names for the account type this frontend has always
// called Consultant (they register through /Accounts/register/consultant).
//
// This is only a fallback: `AuthService.getActiveRoleIds()` resolves the id
// from the account's own `roles` array first, which is authoritative.
export const ROLE_ID_BY_ROLE_NAME = {
   SuperAdmin: UserRolesEnum.SuperAdmin,
   Staff: UserRolesEnum.Staff,
   "International Organization": UserRolesEnum.InternationalOrganization,
   "National Organization": UserRolesEnum.NationalOrganization,
   Donor: UserRolesEnum.Donor,
   Manager: UserRolesEnum.Manager,
   Consultant: UserRolesEnum.Consultant,
   Expert: UserRolesEnum.Consultant,
   Vendor: UserRolesEnum.Consultant,
   Approver: UserRolesEnum.Approver
};

// Where a session lands right after login or after switching role. Keep this the
// single source of truth — both Login and the header's role switcher use it, so
// the two can never drift apart.
export const getRoleLandingPath = (roleName) => {
   if (roleName === "SuperAdmin") return "/admin/workspace";
   if (roleName === "Approver") return "/approver/submissions";
   return "/workspace";
};
